module.exports = __webpack_public_path__ + "public/images/membership_promo_desktop.a7df1affa4032a5d31b7891240f15977.png";